var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.2em",
    height: "1.2em",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9500",
    d: "M17 1h-2a1 1 0 0 0-1 1v16.992h4V2a1 1 0 0 0-1-1m-6 6H9a1 1 0 0 0-1 1v10.992h4V8a1 1 0 0 0-1-1m-6 6H3a1 1 0 0 0-1 1v4.992h4V14a1 1 0 0 0-1-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.603c89773d68a9928c19fee9b891149a.svg";
export { ForwardRef as ReactComponent };